const px = (v, fallback = "0px") => {
  if (v == null || v === "") return fallback;

  const str = String(v);
  if (str === "auto") return "auto";

  // If already has a valid unit, return as-is
  return /(?:px|rem|em|%|vh|vw)$/.test(str) ? str : `${str}px`;
};


export const DEFAULT_STYLES = {
  fontColor: "#111827",
  btnConfigs: { btnBgColor: "#005374", btnFontColor: "#ffffff", btnBorderRadius: 4 },
  widgetBgColor:"#ffffff",
  headerConfigs:{headerBgColor:"#ffffff", headerFontColor:"#111112ff", filterFontColor:"#111112ff"},
  separatorColor: "#68696cff",
  headerLogo: true,
  footerLogo: true,
  showPagination: true,
  perPageRecord: 5,
  width: "100%",
  height: "auto"
};

export const configToTheme = (cfg = DEFAULT_STYLES) => {
  const font = cfg?.fontId || {};
  const safeFontUrl =
    typeof font.fontUrl === "string" && font.fontUrl.trim() !== ""
      ? font.fontUrl
      : null;
  const safeFontName =
    typeof font.fontName === "string" && font.fontName.trim() !== ""
      ? font.fontName
      : null;
  const btn = cfg.btnConfigs || {};
  const header=cfg.headerConfigs ||{};
  
  // normalize API keys -> internal keys
  const btnBgColor =
    btn.btnBgColor ?? btn.bgColor ?? DEFAULT_STYLES.btnConfigs.btnBgColor;
  const btnFontColor =
    btn.btnFontColor ?? btn.fontColor ?? DEFAULT_STYLES.btnConfigs.btnFontColor;
  const btnBorderRadius =
    btn.btnBorderRadius ?? btn.borderRadius ?? DEFAULT_STYLES.btnConfigs.btnBorderRadius;

  
  const headerBgColor=header.headerBgColor ?? DEFAULT_STYLES.headerConfigs.headerBgColor;
  const headerFontColor=header.headerFontColor ?? DEFAULT_STYLES.headerConfigs.headerFontColor;
  const filterFontColor=header.filterFontColor??DEFAULT_STYLES.headerConfigs.filterFontColor;
  const sepratorColor=cfg.separatorColor ?? DEFAULT_STYLES.separatorColor;

  const widgetBgColor=cfg.bgColor ?? DEFAULT_STYLES.widgetBgColor;

  return {
    fontUrl: safeFontUrl,
    fontName: safeFontName,
    colors: {
      font: cfg.fontColor || DEFAULT_STYLES.fontColor,
      btnBg: btnBgColor,
      btnText: btnFontColor,
      widgetBg : widgetBgColor,
      headerBg : headerBgColor,
      headerfont:headerFontColor,
      separator : sepratorColor,
      filterFont:filterFontColor
    },
    radii: {
      btn: px(btnBorderRadius, px(DEFAULT_STYLES.btnConfigs.btnBorderRadius +'px')),
    },
    flags: {
      headerLogo: cfg.headerLogo ?? DEFAULT_STYLES.headerLogo,
      footerLogo: cfg.footerLogo ?? DEFAULT_STYLES.footerLogo,
      showPagination: cfg.showPagination ?? DEFAULT_STYLES.showPagination
    },
    perPage: Number(cfg.perPageRecord || DEFAULT_STYLES.perPageRecord),
    layout: {
      width: cfg.width ? px(cfg.width+'%', "100%") : "100%",
      height: cfg.height ? px(cfg.height+'%', "auto") : "auto"
    }
  };
};
